/**
 * 新版 UI 折线图样式（echart.html 图表 5 — 渐变曲线图）
 */
const echarts = require('echarts/lib/echarts')

const LINE_COLORS = [
    { line: '#1778DB', area: 'rgba(55,125,255,0.37)' },
    { line: '#38CB89', area: 'rgba(56,203,137,0.37)' },
    { line: '#FF8E15', area: 'rgba(255,142,21,0.37)' },
    { line: '#60ADFF', area: 'rgba(96,173,255,0.37)' },
]

const AXIS_STYLE_X = {
    axisLine: { lineStyle: { color: '#e0e6ed' } },
    axisTick: { show: false },
    axisLabel: { color: '#b0b8c4', fontSize: 12 },
}

const AXIS_STYLE_Y = {
    splitLine: { lineStyle: { color: '#f0f2f5' } },
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: { color: '#b0b8c4', fontSize: 12 },
}

const LINE_GRID_BASE = { top: 40,left: 50, right: 20, bottom: 40, containLabel: true }

function areaGradient(color) {
    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color },
        { offset: 1, color: 'rgba(255,255,255,0)' },
    ])
}

function mergeAxisStyle(axis, style) {
    if (!axis) return axis
    const merged = Object.assign({}, axis, style)
    if (style.axisLine) {
        merged.axisLine = Object.assign({}, style.axisLine, axis.axisLine || {})
    }
    if (style.axisTick) {
        merged.axisTick = Object.assign({}, style.axisTick, axis.axisTick || {})
    }
    if (style.axisLabel) {
        merged.axisLabel = Object.assign({}, style.axisLabel, axis.axisLabel || {})
    }
    if (style.splitLine) {
        merged.splitLine = Object.assign({}, style.splitLine, axis.splitLine || {})
    }
    return merged
}

export function styleLineSeries(series, colorIndex) {
    if (!series || series.type !== 'line') return series
    const c = LINE_COLORS[colorIndex % LINE_COLORS.length]
    series.smooth = true
    series.symbol = 'none'
    series.lineStyle = Object.assign({}, series.lineStyle, { color: c.line, width: 1 })
    series.areaStyle = { color: areaGradient(c.area) }
    return series
}

export function getLineTooltip() {
    return {
        trigger: 'axis',
        backgroundColor: '#fff',
        borderColor: '#e8eef5',
        borderWidth: 1,
        padding: [10, 14],
        textStyle: { color: '#333', fontSize: 13 },
        axisPointer: {
            type: 'cross',
            lineStyle: { color: '#c0d0e0', type: 'dashed' },
            crossStyle: { color: '#c0d0e0', type: 'dashed' },
        },
    }
}

/**
 * 将 demo 折线图样式合并到已有 option（保留 data、legend、title 等业务配置）
 */
export function applyLineChartTheme(option) {
    if (!option) return option

    const baseTooltip = getLineTooltip()
    option.tooltip = Object.assign({}, baseTooltip, option.tooltip || {})
    if (!option.tooltip.formatter) {
        option.tooltip.axisPointer = Object.assign({}, baseTooltip.axisPointer, option.tooltip.axisPointer || {})
    }

    const top = option.title && option.title.text ? 50 : 50
    option.grid = Object.assign({}, LINE_GRID_BASE, { top }, option.grid || {})

    if (option.xAxis) {
        if (Array.isArray(option.xAxis)) {
            option.xAxis = option.xAxis.map((x) => mergeAxisStyle(Object.assign({ boundaryGap: false }, x), AXIS_STYLE_X))
        } else {
            option.xAxis = mergeAxisStyle(Object.assign({ boundaryGap: false }, option.xAxis), AXIS_STYLE_X)
        }
    }

    if (option.yAxis) {
        if (Array.isArray(option.yAxis)) {
            option.yAxis = option.yAxis.map((y) => mergeAxisStyle(y, AXIS_STYLE_Y))
        } else {
            option.yAxis = mergeAxisStyle(option.yAxis, AXIS_STYLE_Y)
        }
    }

    if (option.series && Array.isArray(option.series)) {
        let lineIndex = 0
        option.series.forEach((s) => {
            if (s && s.type === 'line') {
                styleLineSeries(s, lineIndex)
                lineIndex += 1
            }
        })
    }

    return option
}
